'use strict';

var _ = require('lodash');
var QuickFilterController = function QuickFilterController($scope, $timeout, configurationService) {
  $scope.productGroups = _.compact(configurationService.getClassGroups());
  var storedSeason = $scope.assignedSeason = true;
  $scope.quickFilterObj = {
    seasons: [],
    dows: []
  };
  $scope.$watch('chartAttributes', function () {
    if ($scope.chartAttributes) {
      $scope.maxDtd = $scope.chartAttributes.maxDtd;
      $scope.seasons = $scope.chartAttributes.seasons;
      $scope.dowGroups = $scope.chartAttributes.dowGroups;
      $scope.seasons = _.union($scope.seasons, [$scope.attributes.season]);
      $scope.dowGroups = _.union($scope.dowGroups, [$scope.attributes.dowGroup]);
    }
    if (_.isUndefined($scope.maxDtd)) {
      $scope.maxDtd = 350;
    }
    $timeout(function () {
      $scope.restoreQuickFilterData();
    }, 0);
  });
  function setComboboxProperties() {
    $scope.seasonsDefined = $scope.quickFilterData.seasons !== undefined;
    $scope.dowsDefined = $scope.quickFilterData.dows !== undefined;
    $scope.seasonsPlaceholder = $scope.seasonsDefined ? 'Value Type' : 'ALL';
    $scope.dowsPlaceholder = $scope.dowsDefined ? 'Value Type' : 'ALL';
  }
  $scope.updateButtonDisabled = function () {
    var quickFilterObj = $scope.quickFilterObj;
    var dtdBelowMax = _.isUndefined($scope.maxDtd) || quickFilterObj.dtd >= 0 && quickFilterObj.dtd <= $scope.maxDtd;
    return _.isNil(quickFilterObj.dtd) || $scope.seasonsDefined && _.isUndefined(quickFilterObj.seasons) || $scope.dowsDefined && _.isUndefined(quickFilterObj.dows) || !dtdBelowMax;
  };
  $scope.onUpdateClick = function () {
    storedSeason = $scope.assignedSeason;
    $scope.$emit('demand-transparency:quick-filter-changed', _.clone($scope.quickFilterObj));
    $scope.closeModal();
  };
  $scope.restoreQuickFilterData = function () {
    var quickFilterData = $scope.quickFilterData;
    if (quickFilterData.classGroup) {
      var quickFilterObj = $scope.quickFilterObj;
      quickFilterObj.dtd = quickFilterData.dtd;
      quickFilterObj.classGroup = quickFilterData.classGroup;
      quickFilterObj.seasons = quickFilterData.seasons;
      quickFilterObj.dows = quickFilterData.dows;
      $scope.assignedSeason = storedSeason;
      setComboboxProperties();
    }
  };
  $scope.onResetClick = function () {
    var originalAttrs = $scope.quickFilterData.originalAttrs;
    var quickFilterObj = $scope.quickFilterObj;
    quickFilterObj.seasons = [originalAttrs.season];
    quickFilterObj.dows = [originalAttrs.dowGroup];
    quickFilterObj.dtd = originalAttrs.dtd;
    quickFilterObj.classGroup = originalAttrs.classGroup;
    $scope.assignedSeason = storedSeason = true;
    setComboboxProperties();
  };
  $scope.$watch('quickFilterObj', function (newVal) {
    if (newVal) {
      var seasonsCount = _.size($scope.quickFilterObj.seasons);
      var dowsCount = _.size($scope.quickFilterObj.dows);
      $scope.populateNumbOfFilter = 1 + seasonsCount + dowsCount + 1;
    }
  }, true);
  $scope.$watch('assignedSeason', function (newVal, oldVal) {
    if (newVal !== oldVal) {
      if (newVal) {
        $scope.quickFilterObj.seasons = [$scope.attributes.season];
        $scope.quickFilterObj.dows = [$scope.attributes.dowGroup];
      }
    }
  });
  $scope.modalOpen = false;
  $scope.toggleModal = function () {
    $scope.modalOpen = !$scope.modalOpen;
  };
  $scope.closeModal = function () {
    $scope.restoreQuickFilterData();
    $scope.modalOpen = false;
  };
};
QuickFilterController.$inject = ['$scope', '$timeout', 'ConfigurationService'];
module.exports = QuickFilterController;